module.exports = __webpack_public_path__ + "img/food.5f4fb09b.jpg";